module.exports = __webpack_public_path__ + "img/empty.266a4842.png";